import { FormGroup, FormControl, Validators } from "@angular/forms";

export var NewRequestForm = new FormGroup({
  DELIVERY_STATE: new FormControl(),
  FULLNAME: new FormControl(),
  CONTRACT_NAME: new FormControl(),
  CONTRACT_EXPNOTE: new FormControl(),
  INTNOTE: new FormControl(),
  REQUEST_STATE: new FormControl(),
  PERSON_ID: new FormControl(),
  EXPIRATION_DT: new FormControl(),
  RESPONSIBLE_PERSON: new FormControl(),
  RESPONSIBLE_PERSON_TEL_NUM: new FormControl(),
  REQUESTOR: new FormControl(),
  ACTIVITY_TYPE: new FormControl(),
  REASON_TYPE: new FormControl(),
  BEGIN_ACTIVITY_DT: new FormControl('', Validators.required),
  END_ACTIVITY_DT: new FormControl('', Validators.required),
  LOCATION_DESC: new FormControl(),
  REQUEST_DT: new FormControl(),
  REQERR_NOTIF: new FormControl(),
  COMPANY: new FormControl(),
  PERSON_EMAIL: new FormControl(),
});

export var CoordinateSearchForm = new FormGroup({
  SEARCH_METHOD: new FormControl(),
  VPO_MUNICIPALITY_DEFAULT: new FormControl(),
  STREET: new FormControl(),
  VPO_HOUSENUMBER_DEFAULT: new FormControl(),
  VPO_CADASTRALUNIT_DEFAULT: new FormControl(),
  VPO_CADASTRALSECTION_DEFAULT: new FormControl(),
  VPO_NOMINATOR_DEFAULT: new FormControl(),
  VPO_DENOMINATOR_DEFAULT: new FormControl(),
  X_LOC_COORD: new FormControl(),
  Y_LOC_COORD: new FormControl(),
  ADDRESS_ID: new FormControl(),
  PARCEL_ID: new FormControl(),
  NOTE: new FormControl(),
  ZIP: new FormControl(),
  LOCATION: new FormControl(),
});

export var MapForm = new FormGroup({
  SCALE: new FormControl(),
  FORMAT: new FormControl(),
  PLOT_FORMAT: new FormControl(),
  MAX_SHAPE_SIZE: new FormControl(),
  MAX_NO_MAPSHEET_REQ: new FormControl(),
  CONTRACT_ID: new FormControl(),
  MapValidator: new FormControl('', Validators.required),
});

export var OverviewForm = new FormGroup({
  G3E_FID: new FormControl(),
  PERSON_ID: new FormControl(),
  DELIVERY_STATE: new FormControl(),
  REQUEST_STATE: new FormControl(),
  ACTIVITY_TYPE: new FormControl(),
  REASON_TYPE: new FormControl(),
  BEGIN_ACTIVITY_DT: new FormControl(),
  END_ACTIVITY_DT: new FormControl(),
  REQUEST_DT: new FormControl(),
  EXPIRATION_DT: new FormControl(),
  RESPONSIBLE_PERSON: new FormControl(),
  RESPONSIBLE_PERSON_TEL_NUM: new FormControl(),
  LOCATION: new FormControl(),
  LOCATION_DESC: new FormControl(),
  COMPANY: new FormControl(),
  REQUESTOR: new FormControl(),
  REQSTATBACKEND: new FormControl(),
  CONTRACT_ID: new FormControl(),
  SCALE: new FormControl(),
  FORMAT: new FormControl(),
  SEARCH_METHOD: new FormControl(),
  ADDRESS_ID: new FormControl(),
  PARCEL_ID: new FormControl(),
  X_LOC_COORD: new FormControl(),
  Y_LOC_COORD: new FormControl(),
  PERSON_EMAIL: new FormControl(),
  PERSON_NOTIF: new FormControl(),
});

export var MapConfig = {
  epServicesUrl: "",
  projectionInitName: "",
  projectionInitDef: "",
  projectionDefault: "",

  mapBoundminX: null,
  mapBoundminY: null,
  mapBoundmaxX: null,
  mapBoundmaxY: null,

  mapMinZoom: 10,
  mapLoadZoom: 18,

  maxGeometries: null,
  maxGeometriesPoint: null,
  maxGeometriesLine: null,
  maxGeometriesPolygon: null,
  maxDistance: null,
  checkOverlap: null,
  maxShapeSize: null,
  maxMapSheet: null,
}

export var MapOptions = {
  role: null,
  x: null,
  y: null,
  centerTransform: null,
  pageWidth: null,
  pageHeight: null,
  scale: null,
  pageOverlap: null,
  g3e_fid: null,
}

export var MapText = {
  CommandDeleteFile: "",
  CommessageDeleteFile: "",
  ConfirmDeleteFile: "",
  ConfirmNo: "",
  ConfirmOK: "",
  ConfirmYes: "",
  ErrmessageDeleteFile: "",
  ErrmessageExpired: "",
  ErrmessageExpiredHead: "",
  LinkTerms: "",
  LoadMapCommand: "",
  LockCompanyConfirmMessage: "",
  LockUserConfirmMessage: "",
  MapEditMode: "",
  MapEditVertices: "",
  MapEditVerticesInact: "",
  MapOpenLegend: "",
  MapPlaceLine: "",
  MapPlacePoint: "",
  MapPlacePolygon: "",
  MapPlacePolyline: "",
  MaxAreaMessage: "",
  MaxDistanceMessage: "",
  MaxGeometriesMessage: "",
  MaxPlotCountMessage: "",
  NoPlotCountMessage: "",
  OverlapMessage: "",
  RelodMapCommand: "",
  RestartAllConfirmMessage: "",
  RestartBusyDialogMessage: "",
  RestartConfirmMessage: "",
  RestartFailedMessage: "",
  RestartRequestConfirmMessage: "",
  UnLockCompanyConfirmMessage: "",
  UnLockUserConfirmMessage: "",
  ValmessageFuturdate: "",
  ValmessageFutureToday: "",
  ValmessagereCaptcha: "",
  ValmessagereCustomLogin: "",
  ValmessageRegister: "",
  ValmessageStartdate: "",
  ValmessageStartdateToday: "",
  ValmessageSubmitted: "",
  ValmessageTerms: "",
  ValmessageValidTo: "",
  WarningCompany: "",
  WarningCompanyHead: "",
}
